import moment from 'moment';
import {
    DISPLAY_DATE_ORDINAL,
    DISPLAY_DATE_DAY_LONG,
    DISPLAY_SHORT_DATE_FORMAT,
} from '@keap-web/shared-ui';
import { billingCycles } from '../money.constants';
import { timeUnitStatus } from '../money.util';

export default {
    computed: {
        invoiceLineItems_invoiceEndDate() {
            const timeUnit = timeUnitStatus(`${this.item.billingCycle}`);

            return moment.utc(this.startDate)
                .startOf('day')
                .add(this.item.numberOfPayments - 1, timeUnit)
                .format();
        },

        invoiceLineItems_adjustRecurringEndDate() {
            if (!this.item) {
                return '';
            }

            return moment.utc(this.item.recurringEndDate)
                .startOf('day')
                .format();
        },

        invoiceLineItems_remainingRecurringCycles() {
            if (!this.item) {
                return 0;
            }

            const timeUnit = timeUnitStatus(`${this.item.billingCycle}`);
            const nextBillDate = moment(this.item.recurringNextBillDate).startOf('day');
            const endDate = moment(this.item.recurringEndDate);
            const remainingCycles = endDate.diff(nextBillDate, timeUnit);

            return remainingCycles > 0 ? remainingCycles : 0;
        },
    },

    methods: {
        invoiceLineItems_recurringFrequencyMessage(date) {
            let day = '';

            switch (this.item.billingCycle) {
            case billingCycles.YEARLY:
                day = moment(date).format(DISPLAY_SHORT_DATE_FORMAT);
                break;
            case billingCycles.MONTHLY:
                day = moment(date).format(DISPLAY_DATE_ORDINAL);
                break;
            case billingCycles.WEEKLY:
                day = moment(date).format(DISPLAY_DATE_DAY_LONG);
                break;
            default:
                day = '';
                break;
            }

            return this.item.billingCycle !== billingCycles.DAILY
                ? this.$t('paymentSchedule.boldFrequency', { day, frequency: this.$tc(`timeInterval.${this.item.billingCycle}`, 1) })
                : this.$t('paymentSchedule.boldEveryDay');
        },
    },
};
